export const prirmaryVariant = 'FhsLogoPrimary';
export const wordmarkVariant = 'FhsLogoWordmark';
export const wordmarkVariantCA = 'FhsLogoWordmarkCA';
